// src/components/Hero.js
import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import icon1 from "../../assets/icon1.png";
import icon2 from "../../assets/icon2.png";
import icon3 from "../../assets/icon3.png";

const Features = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        px: {
          xs: 2, // mobile
          sm: 12, // tablets
          md: 20, // desktops
          xl: 50,
        },
        py: {
          xs: 6, // mobile
          sm: 6, // tablets
          md: 12, // desktops
        },
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {/* First Column */}
        <Grid
          item
          xs={12}
          sm={4}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {/* <AccessTimeIcon sx={{ fontSize: 60, color: "primary.main", mb: 1 }} /> */}
          <Box sx={{ display: "block" }}>
            <img
              src={icon1}
              style={{ maxHeight: "100px", maxWidth: "100%", height: "auto" }}
            />
          </Box>
          <Typography variant="h6" color="primary" fontWeight="bold">
            {t("features.f1.title")}
          </Typography>
          <Typography variant="body2" color="primary" textAlign="center">
            {t("features.f1.description")}
          </Typography>
        </Grid>

        {/* Second Column */}
        <Grid
          item
          xs={12}
          sm={4}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Box sx={{ display: "block" }}>
            <img
              src={icon2}
              style={{ maxHeight: "100px", maxWidth: "100%", height: "auto" }}
            />
          </Box>
          <Typography variant="h6" color="primary" fontWeight="bold">
            {t("features.f2.title")}
          </Typography>
          <Typography variant="body2" color="primary" textAlign="center">
            {t("features.f2.description")}
          </Typography>
        </Grid>

        {/* Third Column */}
        <Grid
          item
          xs={12}
          sm={4}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Box sx={{ display: "block" }}>
            <img
              src={icon3}
              style={{ maxHeight: "100px", maxWidth: "100%", height: "auto" }}
            />
          </Box>
          <Typography variant="h6" color="primary" fontWeight="bold">
            {t("features.f3.title")}
          </Typography>
          <Typography variant="body2" color="primary" textAlign="center">
            {t("features.f3.description")}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Features;
